import { useEffect, useState, useSyncExternalStore } from 'react'

import { loadHostMeetingPrepRemote } from './loadHostMeetingPrepRemote'
import { primaryEmailFromContact } from './primaryEmailFromContact'

const noopSubscribe = () => () => {}
const getZeroSnapshot = () => 0

type HostMeetingPrepRemote = {
  subscribeMeetingBriefCache: (cb: () => void) => () => void
  getMeetingBriefCacheRevision: () => number
  hasValidMeetingBriefCache: (args: {
    contact: {
      id: string
      email: string
      name: string
      company: string
      phoneNumber: string
    }
    meeting?: unknown
  }) => boolean
}

export const useHasValidMeetingBriefCacheFromHost = (
  contact: {
    id: string
    fullName?: string | null
    name?: string | null
    email?: string | null
    emails?: Array<string | { email?: string | null } | null> | null
  } | null,
  meeting: unknown,
): boolean => {
  const [remote, setRemote] = useState<HostMeetingPrepRemote | null>(null)

  useEffect(() => {
    let cancelled = false

    const loadRemote = async () => {
      const mod = await loadHostMeetingPrepRemote()

      if (
        cancelled
        || !mod?.hasValidMeetingBriefCache
        || !mod?.subscribeMeetingBriefCache
        || !mod?.getMeetingBriefCacheRevision
      ) {
        return
      }

      setRemote(mod as HostMeetingPrepRemote)
    }

    loadRemote()

    return () => {
      cancelled = true
    }
  }, [])

  useSyncExternalStore(
    remote?.subscribeMeetingBriefCache ?? noopSubscribe,
    remote?.getMeetingBriefCacheRevision ?? getZeroSnapshot,
    remote?.getMeetingBriefCacheRevision ?? getZeroSnapshot,
  )

  if (!remote?.hasValidMeetingBriefCache || !contact) {
    return false
  }

  const email = primaryEmailFromContact(contact)
  const fullContact = {
    id: contact.id,
    email,
    name: contact.fullName ?? contact.name ?? '',
    company: '',
    phoneNumber: '',
  }

  return remote.hasValidMeetingBriefCache({
    contact: fullContact,
    meeting: meeting ?? null,
  })
}
